import {
  Box,
  Button,
  Flex,
  Image,
  Text,
  useBreakpointValue,
} from "@chakra-ui/react";
import { useState } from "react";
import { IngressoDto } from "core/features/ingresso/typings";
import { formatMoney } from "core/helpers/number";
import colors from "core/resources/theme/colors";
import { Items } from "../CompraIngresso";

interface CardIngressoProps {
  titleCard: string;
  valorIngresso: number;
  valorTotalIngresso?: number;

  id: number;
  fieldOnChange?: (count: number) => void;
  shoppingCart?: Items[];
  form?: IngressoDto | undefined;

  quantity: number;
  addQuantity: () => void;
  removeQuantity: () => void;

  imagemUrl?: string;
  textoInfo?: string;
}

export default function CardIngresso({
  titleCard,
  valorIngresso,
  quantity,
  addQuantity,
  removeQuantity,
  imagemUrl,
  textoInfo,
}: CardIngressoProps) {
  const [showDetails, setShowDetails] = useState(false);
  const isMobile = useBreakpointValue({ base: true, md: false });

  return (
    <Flex
      w="100%"
      rounded="xl"
      overflow="hidden"
      boxShadow="lg"
      flexDir={isMobile ? "column" : "row"}
      bg="white"
      my={4}
      h={isMobile ? "100%" : "160px"}
    >
      <Box
        bgGradient="linear(to-br, orange.400, orange.500)"
        w={isMobile ? "100%" : "220px"}
        position="relative"
        display="flex"
        alignItems="center"
        justifyContent="center"
        px={2}
        py={4}
        borderTopLeftRadius="xl"
        borderBottomLeftRadius={isMobile ? "none" : "xl"}
      >
        {imagemUrl && (
          <Image src={imagemUrl} alt={titleCard} objectFit="cover" />
        )}

        {!isMobile && (
          <Box
            position="absolute"
            right={0}
            top={0}
            bottom={0}
            w="12px"
            zIndex={2}
            bgImage={`repeating-linear-gradient(
              to bottom,
              white 0px,
              white 6px,
              transparent 6px,
              transparent 12px
            )`}
          />
        )}
      </Box>

      <Flex
        flex="1"
        direction="column"
        px={4}
        py={3}
        gap={2}
        justify="space-between"
      >
        <Text fontSize="lg" fontWeight="bold">
          {titleCard}
        </Text>

        <Flex
          mt={2}
          justifySelf="flex-start"
          align="center"
          justify="space-between"
        >
          <Text color={colors.green} fontSize="lg" fontWeight="bold">
            {formatMoney(valorIngresso)}
          </Text>

          <Flex gap={2} align="center">
            <Button
              color={"white"}
              size="xs"
              onClick={removeQuantity}
              bg={colors.newBlue}
              rounded="full"
            >
              -
            </Button>
            <Text fontWeight="medium">{quantity}</Text>
            <Button
              color={"white"}
              size="xs"
              onClick={addQuantity}
              bg={colors.newBlue}
              rounded="full"
            >
              +
            </Button>
          </Flex>
        </Flex>

        {textoInfo && (
          <>
            <Button
              size="sm"
              variant="link"
              colorScheme="blue"
              onClick={() => setShowDetails(!showDetails)}
              alignSelf="flex-start"
              mt={1}
            >
              {showDetails ? "- Detalhes" : "+ Detalhes"}
            </Button>

            {showDetails && (
              <Text
                fontSize="14px"
                color="gray.600"
                mt={1}
                whiteSpace="pre-wrap"
              >
                {textoInfo}
              </Text>
            )}
          </>
        )}
      </Flex>
    </Flex>
  );
}
